"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var OrgEntitlementsManager = /*#__PURE__*/function () {
  OrgEntitlementsManager.$inject = ["$scope", "$route", "$routeParams", "$location", "userService", "modalService"];
  /* @ngInject */
  function OrgEntitlementsManager($scope, $route, $routeParams, $location, userService, modalService) {
    var _this = this;
    _classCallCheck(this, OrgEntitlementsManager);
    this.$scope = $scope;
    this.$route = $route;
    this.$location = $location;
    this.$routeParams = $routeParams;
    this.modalService = modalService;
    this.views = [{
      id: 'org-entitlements',
      label: 'Overview'
    }, {
      id: 'events',
      label: 'Workspaces'
    }, {
      id: 'per-event-entitlements',
      label: 'Workspace Entitlements',
      hideUnlessActive: true
    }, {
      id: 'assign-entitlement',
      label: 'Assign Entitlement',
      hideUnlessActive: true
    }];
    $scope.$on('CHANGE_TAB', function (event, _ref) {
      var tab = _ref.tab,
        params = _ref.params;
      _this.switchView(tab, params, false);
    });
  }

  /**
   * Sets default view
   *
   */
  _createClass(OrgEntitlementsManager, [{
    key: "$onInit",
    value: function $onInit() {
      var _this2 = this;
      var activeTabIndex = 0;
      if (this.$routeParams.tab) {
        activeTabIndex = this.views.findIndex(function (tab) {
          return tab.id === _this2.$routeParams.tab;
        });
      }
      this.activeViewId = this.views[activeTabIndex].id;
    }

    /**
     * Sets the current active view and initiates the needed data the first time the view is shown
     *
     * @param {string} id - The id of the view to be shown
     */
  }, {
    key: "switchView",
    value: function switchView(id, params) {
      var view = this.views.find(function (view) {
        return view.id === id;
      });
      if (view.id === this.activeViewId) return;
      this.$route.updateParams({
        tab: view.id
      });
      if (params) {
        for (var key in params) {
          if (params.hasOwnProperty(key)) {
            var value = params[key];
            this.$location.search(key, value);
          }
        }
      } else {
        this.$location.url(this.$location.path());
      }
    }
  }]);
  return OrgEntitlementsManager;
}();
module.exports = angular.module('backstage.components.orgs.view-org.entitlements-manager', ['backstage.services']).component('bsOrgEntitlementsManager', {
  templateUrl: '/src/angular/components/orgs/view-org/org-entitlements-manager/org-entitlements-manager.html',
  bindings: {
    organisation: '<'
  },
  controllerAs: 'vm',
  controller: OrgEntitlementsManager
}).name;